import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FreeModeCart from './FreeModeCart';
import FreeModeMinStays from './FreeModeMinStays';
import FreeModeRoom from './FreeModeRoom';
import LoyaltyCard from '../../loyalty/LoyaltyCard';
import RoomDetail from '../rooms/RoomDetail';

import {
  BOOKING_STEP, clearRoomSelection, setSelectedRoomDetail, setStep,
} from '../../../actions/Booking';
import { FREE_MODE_ID, LOYALTY_COINS_DISABLED, CALL_CENTER_ROLE } from '../../../constants';
import '../../../static/less/callcenter/callcenter.less';
import LoyaltySelector from '../../loyalty/LoyaltySelector';
//import LoyaltyCoins from '../../loyalty/LoyaltyCoins';
import {
  getMemberInfo,
  LOYALTY_STATUS,
  setCoinsApplied,
  setCoinsEntered,
  setLoggedUser,
  setMaxCoinsToApply,
  setMaxPercentUsage,
  setMemberInfo,
  setSelectedStatus,
  logout,
  setNewMember,
  setNewMemberDiscountPercentage,
  setSaNetRatePercentage,
} from '../../../actions/Loyalty';
import FormControl from '../../common/FormControl';
import { getMaxCoinsToApply, showLoyaltySelector } from '../../../utils';
import LoyaltyLevel from '../../loyalty/LoyaltyLevel';
import withNavigate from '../../../withNavigate'; // Importa el HOC
import {
  getTotalAmountsOfSelectedRoomsInUsdOrEur, getUpperLimit,
} from '../utils';
import NewLoyaltyCard from '../../loyalty/NewLoyaltyCard';

const roomUseToKey = (room) => {
  const use = room.use_requested;
  return `${use.adults}-${use.childs}-${use.infants}`;
};

const buildFlatRoomOptions = (room) => {
  const useKey = roomUseToKey(room);
  const flatOptions = [];
  room.rates.forEach((rate) => {
    const cloneRate = { ...rate };
    delete cloneRate.boards;
    rate.boards.forEach((board) => {
      flatOptions.push({
        board,
        room,
        optionId: `${room.code}__${rate.code}__${board.code}__${useKey}`,
        rate: cloneRate,
      });
    });
  });
  return flatOptions;
};

const buildSingleBoardList = (room) => {
  // Extracts the boards only once, for any board or rate where they appear, so they can be selected
  const allBoards = [];
  const boardCodes = {};
  room.rates.forEach((rate) => {
    rate.boards.forEach((board) => {
      const boardCode = board.code;
      if (!boardCodes[boardCode]) {
        boardCodes[boardCode] = true;
        allBoards.push(board);
      }
    });
  });
  return allBoards;
};

const getRoomOptions = (roomList) => roomList.map((room) => {
  const roomOptions = buildFlatRoomOptions(room);
  const allBoards = buildSingleBoardList(room);

  const cloneRoom = {
    ...room,
    roomId: room.code,
    roomOptions,
    boardList: allBoards,
  };
  delete cloneRoom.rates;
  return cloneRoom;
});

class FreeMode extends React.Component {
  constructor(props) {
    super(props);
    let amount = 0;
    if (props.amount !== null && props.currency !== null) {
      amount = props.amount[props.currency.code];
    }
    this.state = {
      bookingAmount: amount,
      showRoomCodeDetails: null,
      email: {
        name: 'email',
        value: this.props.memberInfo ? this.props.memberInfo.email : '',
        valid: undefined,
        msg: '',
        required: true,
      },
    };

    // Method bindings
    this.onToggleRoomDetails = this.onToggleRoomDetails.bind(this);
    this.onChangeValue = this.onChangeValue.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.validateEmail = this.validateEmail.bind(this);
    this.checkMember = this.checkMember.bind(this);
    this.clearEmailForm = this.clearEmailForm.bind(this);
    this.clearLoyaltyForm = this.clearLoyaltyForm.bind(this);
    this.formPreventDefault = this.formPreventDefault.bind(this);
    this.setLoyaltySelection = this.setLoyaltySelection.bind(this);
    this.updateBookingAmount = this.updateBookingAmount.bind(this);
    this.initializeBookingAmount = this.initializeBookingAmount.bind(this);
  }

  async checkMember(email) {
    this.initializeBookingAmount(); //Puse acá esto para que se seteara state.bookingAmount
    const results = await this.props.getMemberInfo({ email, callcenter_email: this.props.callcenterUser.email });
    if (results) {
      const { info } = results;
      if (info && info.discount_available_percentage) {
        this.props.setMaxPercentUsage(info.discount_available_percentage);
      }
      this.props.setNewMember(info.new_member); //Establecemos si es un miembro nuevo de loyalty para que loyalty le pueda dar el 10% del costo de la reserva en coins
      this.props.setNewMemberDiscountPercentage(info.new_member_discount_percentage);
      this.props.setSaNetRatePercentage(info.sa_net_rate_percentage);
      //Acá debe ir lo mismo que en ReservationDetailsBlock y en RoomTile
      const totalAmounts = getTotalAmountsOfSelectedRoomsInUsdOrEur(this.props);
      if (totalAmounts.totalAmount > 0) {
        const value = getUpperLimit(this.props);
        if (value > 0) {
          this.props.setCoinsEntered(value);
          this.props.setCoinsApplied(value);
          this.props.setMaxCoinsToApply(value);
        }
      }
      this.updateBookingAmount();
    } else {
      if (this.props.selectedStatus === LOYALTY_STATUS.BECOME_MEMBER
        && this.props.new_member_discount_percentage_activated) {
        this.props.logout(true, this.getNewMemberDiscountPercentage());
      } else {
        this.props.logout();
      }
      this.clearLoyaltyForm();
      if (this.props.coinsForRegistering > 0) {
        this.props.setMaxCoinsToApply(this.props.coinsForRegistering);
      }
    }
  }

  clearEmailForm() {
    const email = { ...this.state.email, value: '' };
    this.setState({ email });
    this.props.setLoggedUser(null);
  }

  getNewMemberDiscountPercentage() {
    //Regresa loyalty.newMemberDiscountPercentage
    //Si es 0, regresa this.props.new_member_discount_percentage_chain ya que eso es igual a chain.Data.new_member_discount_percentage
    if (this.props.new_member_discount_percentage != null) {
      if (this.props.new_member_discount_percentage > 0) {
        return this.props.new_member_discount_percentage;
      }

      return this.props.new_member_discount_percentage_chain;
    }
    return this.props.new_member_discount_percentage_chain;
  }

  getCoinsForNewMember(booking_amount) {
    const new_member_discount_percentage = this.getNewMemberDiscountPercentage();
    const percentage = (new_member_discount_percentage * booking_amount) / 100;
    //acá corregir, no debe ser así, debe ser el usd o euros pero no de mx
    const totalDiscountCoinsNewMemberApplied = Number.parseInt(percentage, 10);
    return totalDiscountCoinsNewMemberApplied;
  }

  clearLoyaltyForm(loyaltyStatus = null) {
    if (loyaltyStatus === LOYALTY_STATUS.BECOME_MEMBER
      && this.props.new_member_discount_percentage_activated) {
      /*let amount = 0;
      if (this.props.amount !== null && this.props.currency !== null) {
        amount = this.props.amount[this.props.currency.code];
      }*/
      // Era necesario setear el valor de la booking porque cuando es become_member
      // marcaba error al hacer el cálculo porque this.state.bookingAmount estaba en null
      // cuando estabamos en el método setCoinsForNewMember
      this.props.setNewMember(true);
      this.props.setNewMemberDiscountPercentage(this.getNewMemberDiscountPercentage());
      this.props.setSaNetRatePercentage(0);
      const coinsForNewMember = 0;
      const memberInfo = {
        accountHolder: null, email: '', coinsForNewMember, cardCode: '',
      };
      this.props.setMemberInfo(memberInfo);
      //this.props.setMaxCoinsToApply(coinsForNewMember);//Cuando es become member, le ponemos como maxCoinsToApply
      //el porcentaje de descuento según su nivel de loyalty, no le sumamos los coins que tiene la persona porque
      //como tal todavía no tiene coins, tal vez le pudieramos sumar los coinsForRegistering pero tal vez está bien
      //sólo dejar que use el newMemberDiscountPercentage por su nivel de loyalty
      this.updateBookingAmount();
    } else {
      const selectedStatus = loyaltyStatus || this.props.selectedStatus;
      const availableCoins = selectedStatus === LOYALTY_STATUS.BECOME_MEMBER ? this.props.coinsForRegistering : 0;
      const memberInfo = {
        accountHolder: null, email: '', availableCoins, cardCode: '',
      };
      this.props.setMemberInfo(memberInfo);
      const maxCoins = selectedStatus === LOYALTY_STATUS.IS_MEMBER
      && memberInfo.email === '' ? 0 : getMaxCoinsToApply(this.state.bookingAmount);
      this.props.setMaxCoinsToApply(maxCoins);
      this.updateBookingAmount();
    }
  }

  componentWillUnmount() {
    if (this.props.hotel) {
      // Clearing data from previous selection
      this.props.setStep(BOOKING_STEP.CHOOSE);
      this.props.clearRoomDetail();
      this.props.clearRoomSelection(true); // true to send "emptyCartEvent" (as rooms are getting cleared)
    } else {
      this.props.navigate('/');
    }
    if (this.props.selectedStatus === LOYALTY_STATUS.IS_MEMBER) {
      /*const maxCoins = getMaxCoinsToApply(this.state.bookingAmount);
      console.log('maxCoins:');
      console.log(maxCoins);
      console.log('tema:');
      console.log(maxCoins+(getCoinsMaximosATomarEnCuenta(this.props)));
      this.props.setMaxCoinsToApply(maxCoins+(getCoinsMaximosATomarEnCuenta(this.props)));*/
    } else if (this.props.showLoyalty === LOYALTY_COINS_DISABLED) {
      this.props.setMaxCoinsToApply(0);
      this.updateBookingAmount();
    } else if (this.props.selectedStatus === LOYALTY_STATUS.DONT_WANT_MEMBER) {
      this.clearLoyaltyForm(LOYALTY_STATUS.DONT_WANT_MEMBER);
    } else if (this.props.new_member_discount_percentage_activated) {
      /*const coinsForNewMember = this.getCoinsForNewMember(this.state.bookingAmount);
      console.log('tema:');
      console.log(coinsForNewMember+(getCoinsMaximosATomarEnCuenta(this.props)));
      this.props.setMaxCoinsToApply(coinsForNewMember+(getCoinsMaximosATomarEnCuenta(this.props)));
      //El maxCoinsToApply sería el descuento newMemberDiscountPercentage sobre el costo total
      //de la reserva más los coins que tenga el usuario que puede también ocupar
      this.updateBookingAmount(coinsForNewMember+(getCoinsMaximosATomarEnCuenta(this.props)));*/
    } else {
      this.props.setMaxCoinsToApply(this.props.coinsForRegistering);
      this.updateBookingAmount();
    }
  }

  formPreventDefault(e) {
    e.preventDefault();
  }

  isMember() {
    return this.props.selectedStatus === LOYALTY_STATUS.IS_MEMBER;
  }

  normalizeText(text) {
    // Used for take the text with normalize format.
    return text.trim().toLowerCase();
  }

  onChangeValue(fieldName, event) {
    const { value } = event.target;
    const updatedState = {
      value,
    };

    this.setState({
      [fieldName]: { ...this.state[fieldName], ...updatedState },
    }, () => {
      // Aquí puedes acceder al nuevo estado
      const fieldValidate = this.validateEmail();
      updatedState.valid = fieldValidate.valid;
      updatedState.msg = fieldValidate.msg;
      if (updatedState.valid) {
        this.checkMember(this.state.email.value); // Esto ahora tendrá el valor actualizado
      } else {
        this.props.logout();
        this.clearLoyaltyForm();
      }
    });
  }

  onKeyUp(event) {
    if (event.charCode === 13) {
      this.onChangeValue('email', event);
    }
  }

  onToggleRoomDetails(room) {
    this.setState({ showRoomCodeDetails: room ? room.code : null });
  }

  render() {
    const { state } = this;
    const { hotel } = this.props;
    const emptyHotelError = this.renderEmptyHotel(hotel);
    if (emptyHotelError) {
      return emptyHotelError;
    }
    const roomItems = getRoomOptions(hotel.rooms[FREE_MODE_ID]);

    return (
            <div>
              {showLoyaltySelector() && (
                      <div>
                        <LoyaltySelector onSelect={(ev) => this.setLoyaltySelection(ev)}/>
                        <div className="FreeMode row">
                          <div className='col-xs-12 col-md-9'>
                            {/* eslint-disable-next-line react/no-string-refs */}
                            <form ref="loyMemberUserForm" noValidate onSubmit={this.formPreventDefault}
                                  className={!this.isMember() ? 'hidden' : ''}>
                              <FormControl
                                      className="w-full"
                                      inputData={state.email}
                                      label={this.context.t('Enter your member email or Loyalty Number here.')}
                                      onChange={this.onChangeValue}
                              >
                                <input
                                        type="text"
                                        minLength={5}
                                        maxLength={100}
                                        onKeyPress={this.onKeyUp}
                                />
                              </FormControl>
                            </form>
                          </div>
                        </div>
                      </div>
              )
              }
              <div className="FreeMode row">
                {this.renderSelectedRoomDetail(hotel, roomItems)}
                <div className="col-xs-12 col-md-9">
                  {roomItems.map((roomItem) => (
                          <FreeModeRoom key={roomItem.roomId} room={roomItem} hotel={hotel}
                                        onShowRoomPopUp={() => this.onToggleRoomDetails(roomItem)}
                                        checkMember={this.checkMember}/>
                  ))}
                </div>
                <div className="col-xs-12 col-md-3">
                  <div className={!this.wantToBeMember() ? 'hidden' : ''}>
                    <LoyaltyCard name={this.props.memberInfo ? this.props.memberInfo.accountHolder : ''}
                                 availableCoins={this.props.memberInfo
                                   ? this.props.memberInfo.availableCoins : this.props.coinsForRegistering}
                                 usedCoins={this.props.coinsApplied ? this.props.coinsApplied : 0}
                                 maxPercentUsage={this.props.maxPercentUsage}/>
                    <LoyaltyLevel level={this.props.memberInfo ? this.props.memberInfo.membershipName : null}/>
                    {this.props.memberInfo != null
                    && <NewLoyaltyCard mostrarExtras={true} soloMostrarCoins={true}
                      shouldShowTitle={true} shouldShowOnlyImage={false}></NewLoyaltyCard>}
                    {/*this.renderCoinsUsageReminder()*/}
                  </div>
                  <FreeModeMinStays/>
                  <FreeModeCart availableCoins={this.props.memberInfo ? this.props.memberInfo.availableCoins : 0}
                                usedCoins={this.props.coinsApplied ? this.props.coinsApplied : 0}/>
                </div>
              </div>
            </div>
    );
  }

  renderCoinsUsageReminder() {
    if (this.props.new_member === true && this.props.new_member_discount_percentage_activated) {
      return (
        <div className='text-xs py-2'>{this.context.t('* New members get a ')}{this.getNewMemberDiscountPercentage()}{this.context.t(' % discount')}</div>);
    }
    if (this.props.maxPercentUsage) {
      return (
              <div className='text-xs py-2'>{this.context.t('* Redeem coins to obtain discounts up to ')}{this.props.maxPercentUsage}%</div>);
    }
    return null;
  }

  renderEmptyHotel(hotel) {
    let error = null;
    if (!hotel) {
      error = this.context.t('Hotel results could not be loaded');
    } else if (!hotel.rooms || !hotel.rooms[FREE_MODE_ID]) {
      error = this.context.t('Hotel was returned without rooms');
    } else {
      return null;
    }
    return (
            <p className="row m-4 p-4 FreeMode__error">
              {error}
            </p>
    );
  }

  renderSelectedRoomDetail(hotel) {
    const rooms = hotel.rooms[FREE_MODE_ID];
    const room = rooms.find((r) => r.code === this.state.showRoomCodeDetails);
    if (!room) {
      return null;
    }
    return (
            <RoomDetail room={room} onCloseRoomDetails={() => this.onToggleRoomDetails(null)}/>
    );
  }

  setLoyaltySelection(loyaltyStatus) {
    this.clearEmailForm();
    this.clearLoyaltyForm(loyaltyStatus);
    this.props.setSelectedStatus(loyaltyStatus);
    if (loyaltyStatus === LOYALTY_STATUS.BECOME_MEMBER
      && this.props.new_member_discount_percentage_activated) {
      this.props.logout(true, this.getNewMemberDiscountPercentage());
    } else {
      this.props.logout();
    }
  }

  initializeBookingAmount() {
    let amount = 0;
    if (this.props.amount !== null && this.props.currency !== null) {
      amount = this.props.amount[this.props.currency.code];
    }
    this.setState({ bookingAmount: amount });
  }

  updateBookingAmount() {
    let amount = 0;
    if (this.props.amount !== null && this.props.currency !== null) {
      amount = this.props.amount[this.props.currency.code];
    }
    this.setState({ bookingAmount: amount });
  }

  validateEmail() {
    const { email } = this.state;
    const emailValue = this.normalizeText(email.value);

    let emailValidation = { valid: true, msg: '' };
    // Verificar si el campo está vacío
    if (emailValue === '') {
      emailValidation = {
        valid: false,
        msg: this.context.t('Please review your e-mail address'),
      };
    } else {
      // Validar el formato del correo electrónico
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Expresión regular básica para emails
      if (!emailRegex.test(emailValue)) {
        emailValidation = {
          valid: false,
          msg: this.context.t('Please enter a valid email address'),
        };
      }
    }
    return emailValidation;
  }

  wantToBeMember() {
    return this.props.selectedStatus !== LOYALTY_STATUS.DONT_WANT_MEMBER;
  }
}

FreeMode.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

FreeMode.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  cart: state.cart,
  lang: state.i18nState.lang,
  loyalty: state.loyalty,
  chain: state.bookingFormState.chain,
  hotel: state.booking.hotel,
  selectedRoomDetail: state.booking.selectedRoomDetail,
  memberInfo: state.loyalty.memberInfo,
  selectedStatus: state.loyalty.selectedStatus,
  coinsForRegistering: state.loyalty.coinsForRegistering,
  coinsApplied: state.loyalty.coinsApplied,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  maxPercentUsage: state.loyalty.maxPercentUsage,
  userCurrency: state.booking.filterCurrency,
  amount: state.cart.amount,
  currency: state.cart.cartHotel.currency,
  callcenterUser: state.session.user,
  showLoyalty: state.session.chainData.loyalty_coins_active,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  multipleRoomSelection: state.booking.multipleRoomSelection,
  conversionRates: state.loyalty.conversionRates,
  //currency: state.booking.filterCurrency,
  enteredCoins: state.loyalty.coinsEntered,
  maxCoinsToApply: state.loyalty.maxCoinsToApply,
  loggedUser: state.loyalty.loggedUser,
  distributions: state.bookingFormState.distributions.length > 0 ? state.bookingFormState.distributions
    : state.cart.cartHotel.rooms.map((room) => room.distribution),

  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  multipleRoomStep: state.booking.multipleRoomStep,
  nights: state.booking.last_requested_info.nights,
  coinsEntered: state.loyalty.coinsEntered,
  //isLoyaltyUserLoggedIn: isEmailPresent || isBecomeMemberStatus,
  isCartUpdating: state.cart.isUpdating,
  currencies: state.booking.currencies,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
});

const mapDispatchToProps = (dispatch) => ({
  setStep: (payload) => dispatch(setStep(payload)),
  clearRoomDetail: () => dispatch(setSelectedRoomDetail({})),
  clearRoomSelection: (payload) => dispatch(clearRoomSelection(payload)),
  getMemberInfo: (payload) => dispatch(getMemberInfo(payload)),
  setMemberInfo: (payload) => dispatch(setMemberInfo(payload)),
  setMaxPercentUsage: (payload) => dispatch(setMaxPercentUsage(payload)),
  setMaxCoinsToApply: (payload) => dispatch(setMaxCoinsToApply(payload)),
  setCoinsEntered: (payload) => dispatch(setCoinsEntered(payload)),
  setCoinsApplied: (payload) => dispatch(setCoinsApplied(payload)),
  setSelectedStatus: (payload) => dispatch(setSelectedStatus(payload)),
  logout: (newMember, newMemberDiscountPercentage) => dispatch(logout(newMember, newMemberDiscountPercentage)),
  setLoggedUser: (payload) => dispatch(setLoggedUser(payload)),
  setNewMember: (payload) => dispatch(setNewMember(payload)),
  setNewMemberDiscountPercentage: (payload) => dispatch(setNewMemberDiscountPercentage(payload)),
  setSaNetRatePercentage: (payload) => dispatch(setSaNetRatePercentage(payload)),
});

const ConnectedFreeMode = connect(mapStateToProps, mapDispatchToProps)(FreeMode);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedFreeMode);
